import { IUserLeaderboardViewModel } from 'fitbeat.models';
import { OPEN_HOME_WORKOUT_SUCCESS } from '../HomeWorkouts';
import { REMOVE_TARGET_SUCCESS, REQUEST_WEIGHT_TARGET_INFO_SUCCESS } from '../WeightTarget/actionTypes';
import {
  ALL_DASHBOARD_BLOG_HELP_FAILURE,
  ALL_DASHBOARD_BLOG_HELP_REQUEST,
  ALL_DASHBOARD_BLOG_HELP_SUCCESS,
  ALL_DASHBOARD_BLOG_INSIGHTS_REQUEST,
  ALL_DASHBOARD_BLOG_INSIGHTS_SUCCESS,
  CLOSE_LEADERBOARD_MODAL,
  DASHBOARD_BLOG_INSIGHTS_FAILURE,
  DASHBOARD_BLOG_INSIGHTS_REQUEST,
  DASHBOARD_BLOG_INSIGHTS_SUCCESS,
  JOIN_LEADERBOARD_FAILURE,
  JOIN_LEADERBOARD_REQUEST,
  JOIN_LEADERBOARD_SUCCESS,
  OPEN_LEADERBOARD_MODAL, SELECT_TEAM, SHOW_TEAM_SELECT_SCREEN,
  USER_GOAL_CHANGED,
  WEEKLY_GOAL_DATA_FAILURE,
  WEEKLY_GOAL_DATA_REQUEST,
  WEEKLY_GOAL_DATA_SUCCESS,
  WEIGHT_TARGET_AND_MILESTONE_FAILURE,
  WEIGHT_TARGET_AND_MILESTONE_REQUEST,
  WEIGHT_TARGET_AND_MILESTONE_SUCCESS,
  WORKOUT_TILE_DATA_FAILURE,
  WORKOUT_TILE_DATA_REQUEST,
  WORKOUT_TILE_DATA_SUCCESS,
} from './actionTypes';
import { IWeeklyGoalData } from './types';

export interface ISummaryDashboardState {
  view: {
    isTrackingLoading: boolean;
    isWorkoutLoading: boolean;
    isTargetWeightInfoLoading: boolean;
    isNutritionLoading: boolean;
    trackingError: null | Error;
    nutritionError: null | Error;
    insightBlogPostsLoading: boolean;
    insightBlogPostsFailure: boolean;
    helpBlogPostsLoading: boolean;
    helpBlogPostsFailure: boolean;
    seeAllInsightsLoading: boolean;
    workoutError: null | Error;
    requiresCurrentMonthBodyScan: boolean;
    requiresNutritionRating: boolean;
    scanDate: null | Date,
    isWorkout: boolean;
    isBodyFat: boolean;
    isFetchingWeeklyGoalData: boolean;
    weeklyGoalDataError: boolean;
    isSeeAllInsights: boolean;
    seeAllHelpPostsRequestInProgress: boolean;
    isShowingAllHelpPosts: boolean;
    isLeaderboardModalVisible: boolean;
    shouldShowSelectTeamScreen: boolean;
    didOpenLeaderboardModalFromDashboard: boolean;
    isJoiningLeaderboard: boolean;
  };
  data: {
    trackingData: any;
    nutritionData: any;
    totalStartedWorkouts: null | number;
    weeklyGoalData: IWeeklyGoalData | null;
    weightTargetInfo: any;
    insightBlogs: any;
    helpBlogs: any;
    selectedLeaderboard: IUserLeaderboardViewModel | null;
    selectedTeam: string | null;
  };
}

export default (state: ISummaryDashboardState = {
  view: {
    isTrackingLoading: false,
    isWorkoutLoading: false,
    isTargetWeightInfoLoading: false,
    isNutritionLoading: false,
    trackingError: null,
    nutritionError: null,
    insightBlogPostsLoading: false,
    insightBlogPostsFailure: false,
    helpBlogPostsLoading: false,
    helpBlogPostsFailure: false,
    seeAllInsightsLoading: false,
    workoutError: null,
    requiresCurrentMonthBodyScan: false,
    requiresNutritionRating: false,
    scanDate: null,
    isWorkout: false,
    isBodyFat: false,
    isFetchingWeeklyGoalData: false,
    weeklyGoalDataError: false,
    isSeeAllInsights: false,
    seeAllHelpPostsRequestInProgress: false,
    isShowingAllHelpPosts: false,
    isLeaderboardModalVisible: false,
    didOpenLeaderboardModalFromDashboard: false,
    isJoiningLeaderboard: false,
    shouldShowSelectTeamScreen: false,
  },
  data: {
    trackingData: null,
    nutritionData: null,
    totalStartedWorkouts: null,
    weeklyGoalData: null,
    weightTargetInfo: {},
    insightBlogs: [],
    helpBlogs: [],
    selectedLeaderboard: null,
    selectedTeam: null,
  },
}, action) => {
  switch (action.type) {
    // WORKOUT
    case WORKOUT_TILE_DATA_REQUEST: {
      return {
        view: {
          ...state.view,
          isWorkoutLoading: action.payload.hideLoader ? false : true,
          workoutError: null,
        },
        data: {
          ...state.data,
        },
      };
    }
    case WORKOUT_TILE_DATA_SUCCESS: {
      return {
        view: {
          ...state.view,
          isWorkoutLoading: false,
        },
        data: {
          ...state.data,
          totalStartedWorkouts: action.payload.workoutData.totalStartedWorkouts,
        },
      };
    }
    case WORKOUT_TILE_DATA_FAILURE: {
      return {
        view: {
          ...state.view,
          isWorkoutLoading: false,
          workoutError: action.payload,
        },
        data: {
          ...state.data,
        },
      };
    }
    // MEAL
    case OPEN_HOME_WORKOUT_SUCCESS: {
      return {
        view: {
          ...state.view,
        },
        data: {
          ...state.data,
          totalStartedWorkouts: !!state.data.totalStartedWorkouts
            ? state.data.totalStartedWorkouts + 1 : 1,
        },
      };
    }
    case WEEKLY_GOAL_DATA_REQUEST: {
      return {
        view: {
          ...state.view,
          isFetchingWeeklyGoalData: !state.data.weeklyGoalData,
        },
        data: {
          ...state.data,
        },
      };

    }
    case WEEKLY_GOAL_DATA_SUCCESS: {
      return {
        view: {
          ...state.view,
          isFetchingWeeklyGoalData: false,
          weeklyGoalDataError: false
        },
        data: {
          ...state.data,
          weeklyGoalData: action.payload,
        },
      };
    }
    case REQUEST_WEIGHT_TARGET_INFO_SUCCESS: {
      const weightTargetInfo = action.payload.weightTargetInfo;
      const targetReached = weightTargetInfo && weightTargetInfo.target && weightTargetInfo.target.reached;
      return {
        view: {
          ...state.view,
        },
        data: {
          ...state.data,
          weeklyGoalData: {
            ...state.data.weeklyGoalData,
            ...targetReached ? {
              target: undefined,
              milestone: undefined,
            } : weightTargetInfo,
          },
        },
      };
    }
    case USER_GOAL_CHANGED: {
      return {
        view: {
          ...state.view,
        },
        data: {
          ...state.data,
          weeklyGoalData: {
            weightTargetInfo: {
              target: undefined,
              milestone: undefined,
            },
          },
        },
      };
    }
    case REMOVE_TARGET_SUCCESS: {
      return {
        view: {
          ...state.view,
        },
        data: {
          ...state.data,
          weeklyGoalData: {
            weightTargetInfo: {
              target: undefined,
              milestone: undefined,
            },
          },
        },
      };
    }
    case WEEKLY_GOAL_DATA_FAILURE: {
      return {
        view: {
          ...state.view,
          isFetchingWeeklyGoalData: false,
          weeklyGoalDataError: true,
        },
        data: {
          ...state.data,
        },
      };
    }
    case DASHBOARD_BLOG_INSIGHTS_REQUEST: {
      const setLoading = state.data.insightBlogs.length === 0;
      return {
        view: {
          ...state.view,
          insightBlogPostsLoading: setLoading,
        },
        data: {
          ...state.data,
        },
      };
    }
    case DASHBOARD_BLOG_INSIGHTS_SUCCESS: {
      return {
        view: {
          ...state.view,
          insightBlogPostsLoading: false,
          insightBlogPostsFailure: false,
          isSeeAllInsights: false,
        },
        data: {
          ...state.data,
          insightBlogs: action.payload,
        },
      };
    }
    case ALL_DASHBOARD_BLOG_INSIGHTS_REQUEST: {
      return {
        view: {
          ...state.view,
          seeAllInsightsLoading: true,
        },
        data: {
          ...state.data,
        },
      };
    }
    case ALL_DASHBOARD_BLOG_INSIGHTS_SUCCESS: {
      return {
        view: {
          ...state.view,
          seeAllInsightsLoading: false,
          isSeeAllInsights: true,
        },
        data: {
          ...state.data,
          insightBlogs: action.payload,
        },
      };
    }
    case DASHBOARD_BLOG_INSIGHTS_FAILURE: {
      return {
        view: {
          ...state.view,
          insightBlogPostsLoading: false,
          insightBlogPostsFailure: true,
        },
        data: {
          ...state.data,
        },
      };
    }
    case ALL_DASHBOARD_BLOG_HELP_FAILURE: {
      return {
        view: {
          ...state.view,
          helpBlogPostsLoading: false,
          helpBlogPostsFailure: true,
        },
        data: {
          ...state.data,
        },
      };
    }
    case ALL_DASHBOARD_BLOG_HELP_REQUEST: {
      const setLoading = state.data.helpBlogs.length === 0;
      return {
        view: {
          ...state.view,
          seeAllHelpPostsRequestInProgress: setLoading,
        },
        data: {
          ...state.data,
        },
      };
    }
    case ALL_DASHBOARD_BLOG_HELP_SUCCESS: {
      return {
        view: {
          ...state.view,
          seeAllHelpPostsRequestInProgress: false,
          isShowingAllHelpPosts: true,
        },
        data: {
          ...state.data,
          helpBlogs: action.payload,
        },
      };
    }
    case WEIGHT_TARGET_AND_MILESTONE_REQUEST: {
      return {
        view: {
          ...state.view,
          isTargetWeightInfoLoading: action.payload.hideLoader ? false : true,
        },
        data: {
          ...state.data,
        },
      };
    }
    case WEIGHT_TARGET_AND_MILESTONE_SUCCESS : {
      return {
        view: {
          ...state.view,
          isTargetWeightInfoLoading: false,
        },
        data: {
          ...state.data,
          weightTargetInfo: action.payload,
        },
      };
    }
    case WEIGHT_TARGET_AND_MILESTONE_FAILURE: {
      // TODO: add error message
      return {
        view: {
          ...state.view,
          isTargetWeightInfoLoading: false,
        },
        data: {
          ...state.data,
        },
      };
    }
    case OPEN_LEADERBOARD_MODAL: {
      return {
        view: {
          ...state.view,
          isLeaderboardModalVisible: true,
          shouldShowSelectTeamScreen: action.payload.shouldShowSelectTeamScreen,
          didOpenLeaderboardModalFromDashboard: action.payload.didOpenLeaderboardModalFromDashboard,
        },
        data: {
          ...state.data,
          selectedLeaderboard: action.payload.selectedLeaderboard,
          selectedTeam: null,
        },
      };
    }
    case CLOSE_LEADERBOARD_MODAL: {
      return {
        view: {
          ...state.view,
          isLeaderboardModalVisible: false,
          shouldShowSelectTeamScreen: false,
        },
        data: {
          ...state.data,
          selectedLeaderboard: null,
          selectedTeam: null,
        },
      };
    }
    case SELECT_TEAM: {
      return {
        view: {
          ...state.view,
        },
        data: {
          ...state.data,
          selectedTeam: action.payload,
        },
      };
    }
    case JOIN_LEADERBOARD_REQUEST: {
      return {
        view: {
          ...state.view,
          isJoiningLeaderboard: true,
        },
        data: {
          ...state.data,
        },
      };
    }
    case JOIN_LEADERBOARD_SUCCESS: {
      return {
        view: {
          ...state.view,
          isJoiningLeaderboard: false,
          shouldShowSelectTeamScreen: false,
        },
        data: {
          ...state.data,
          selectedLeaderboard: action.payload.updatedLeaderboard,
        },
      };
    }
    case JOIN_LEADERBOARD_FAILURE: {
      return {
        view: {
          ...state.view,
          isJoiningLeaderboard: false,
        },
        data: {
          ...state.data,
        },
      };
    }
    case SHOW_TEAM_SELECT_SCREEN: {
      return {
        view: {
          ...state.view,
          shouldShowSelectTeamScreen: true,
        },
        data: {
          ...state.data,
        },
      };
    }

    default:
      return state;
  }
};
